var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',[_vm._v("退会されています。")]),_vm._m(0),_c('p',[_vm._v("お問い合わせは下記のメールアドレスにお送り下さい。")]),_c('p',[_vm._v("運営事務局："+_vm._s(_vm.settingData.inquiry_mail))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" お客様はすでに退会済みとなっております。"),_c('br'),_vm._v(" ご利用ありがとうございました。 ")])
}]

export { render, staticRenderFns }